import React, { Component } from 'react';
import AboutUs from './AboutUs';
import { Menu } from './Menu';

import { AuditAttack } from './AuditAttack';
import { AuditAttackTwo } from './AuditAttackTwo';
import { FloatyWords} from './FloatyWords';

import { ABCDrop} from './ABCDrop';
import { BurpCow} from './BurpCow';
import { FirstThen} from './FirstThen';
import { ReadySetReady } from './ReadySetReady';
import  WobblyABC  from './WobblyABC';
import { NoAskTask } from './NoAskTask';

import { Home } from './Home';
import { Privacy } from './Privacy';
import {BrowserRouter as Router, Route} from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
//import { loadReCaptcha } from 'react-recaptcha-v3';

class App extends Component {
  constructor(props) {
    super(props)

  }



  componentDidMount() {
   // loadReCaptcha('6LfJNbsUAAAAANip03PwjTL7d2Tb4Jf3TadUdD9g');

  }


  render() {
    
    return (

      <Router>
          
      <Menu /> 
      <br />
      <div className="container">
      <Route exact path = "/" component ={Home}/>
      <Route path = "/floatywords" component ={FloatyWords}/>
	    <Route path = "/abcdrop" component ={ABCDrop}/>
	    <Route path = "/noasktask" component ={NoAskTask}/>
	    <Route path = "/firstthen" component ={FirstThen}/>
	    <Route path = "/burpcow" component ={BurpCow}/>
	    <Route path = "/auditattack" component ={AuditAttack}/>
	    <Route path = "/auditattacktwo" component ={AuditAttackTwo}/>
	    <Route path = "/aboutus" component ={AboutUs}/>
	    <Route path = "/readysetready" component ={ReadySetReady}/>
	    
	    <Route path = "/wobblyabc" component ={WobblyABC}/>
	    <Route path = "/privacy" component ={Privacy}/>
	  
    </div>
    
</Router>
      
    );
  }
}

export default App;
